const ADS_PROPAGATION_CONTENTS = [
  {
    key: "web",
    name: "Web",
    icon: require("@/assets/ico-world.svg"),
  },
  // {
  //   name: "Facebook",
  //   key: "facebook",
  //   icon: "ico-fb-circle.svg",
  // },
]

const ADS_CAMPAIGN_OBJECTIVES = [
  {
    key: "LINK_CLICKS",
    name: "Návštěvnost",
    hint:
      "Také známá jako proklik na stránku nebo traffic kampaň. Promujte a řiďte traffic na váš web.",
  },
  {
    key: "CONVERSIONS",
    name: "Konverze",
    hint:
      "Ukažte reklamy lidem, kteří na vašem webu nejpravděpodobněji provedou hodnotnou akci, jako třeba nákup nebo přidání platebních údajů.",
  },
]

const ADS_BUDGET_TYPES = [
  {
    key: "daily",
    name: "Denní rozpočet",
  },
  {
    key: "lifetime",
    name: "Celkový rozpočet",
  },
]

const ADS_CALL_TO_ACTION_TYPES = [
  {
    key: "LEARN_MORE",
    name: "Další informace",
  },
  {
    key: "APPLY_NOW",
    name: "Požádat",
  },
  {
    key: "BOOK_TRAVEL",
    name: "Rezervovat",
  },
  {
    key: "CONTACT_US",
    name: "Kontaktujte nás",
  },
  {
    key: "DOWNLOAD",
    name: "Stáhnout",
  },
  {
    key: "GET_OFFER",
    name: "Získat nabídku",
  },
  {
    key: "GET_QUOTE",
    name: "Získat cenovou nabídku",
  },
  {
    key: "LISTEN_NOW",
    name: "Poslechnout si",
  },
  {
    key: "PLAY_GAME",
    name: "Hrát hru",
  },
  {
    key: "REQUEST_TIME",
    name: "Požádat o konkrétní čas",
  },
  {
    key: "SEE_MENU",
    name: "Zobrazit menu",
  },
  {
    key: "SHOP_NOW",
    name: "Koupit",
  },
  {
    key: "SIGN_UP",
    name: "Zaregistrovat se",
  },
  {
    key: "SUBSCRIBE",
    name: "Přihlásit odběr",
  },
  {
    key: "WATCH_MORE",
    name: "Zhlédnout další",
  },
  {
    key: "WHATSAPP_MESSAGE",
    name: "Poslat zprávu přes WhatsApp",
  },
  {
    key: "GET_SHOWTIMES",
    name: "Zobrazit promítací časy",
  },
]

const ADS_CUSTOM_EVENT_TYPES = [
  {
    key: "LEAD",
    name: "Potenciální zákazník",
  },
  {
    key: "CONTENT_VIEW",
    name: "Zobrazení obsahu",
  },
  {
    key: "COMPLETE_REGISTRATION",
    name: "Dokončení registrace",
  },
  {
    key: "CONTACT",
    name: "Kontaktování",
  },
  {
    key: "PURCHASE",
    name: "Nákup",
  },
  {
    key: "SUBMIT_APPLICATION",
    name: "Odeslání žádosti",
  },
  {
    key: "SCHEDULE",
    name: "Plán",
  },
  {
    key: "INITIATED_CHECKOUT",
    name: "Přechod k zaplacení",
  },
  {
    key: "ADD_TO_CART",
    name: "Přidání do košíku",
  },
  {
    key: "ADD_TO_WISHLIST",
    name: "Přidání na seznam přání",
  },
  {
    key: "SUBSCRIBE",
    name: "Přihlášení odběru",
  },
  {
    key: "DONATE",
    name: "Přispění",
  },
  {
    key: "CUSTOMIZE_PRODUCT",
    name: "Přizpůsobení produktu",
  },
  {
    key: "START_TRIAL",
    name: "Spuštění zkušebního období",
  },
  {
    key: "FIND_LOCATION",
    name: "Vyhledání lokality",
  },
  {
    key: "SEARCH",
    name: "Vyhledávání",
  },
  {
    key: "ADD_PAYMENT_INFO",
    name: "Zadání platebních údajů",
  },
]

export {
  ADS_BUDGET_TYPES,
  ADS_CALL_TO_ACTION_TYPES,
  ADS_CUSTOM_EVENT_TYPES,
  ADS_PROPAGATION_CONTENTS,
  ADS_CAMPAIGN_OBJECTIVES,
}
